import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { PageParams, Paginated, RequestedFeature } from "@vixi/types";

interface RequestedFeaturesQueryParams extends PageParams {
  isActive?: boolean;
}

export const requestedFeaturesQueryOptions = ({
  isActive,
  pageSize = 10000,
  pageNumber = 1,
}: Partial<RequestedFeaturesQueryParams> = {}) => {
  return queryOptions({
    queryKey: ["requested-features", isActive, pageSize, pageNumber],
    queryFn: async () => {
      const response = await api.get<Paginated<RequestedFeature>>(endpoints.getSuggestedFeatures, {
        params: {
          pageNumber,
          pageSize,
          isActive,
        } satisfies RequestedFeaturesQueryParams,
      });

      if (isActive) {
        response.data.items = response.data.items?.map((item) => ({
          ...item,
          isActive: true,
        }));
      }

      return response.data;
    },
  });
};

export const useRequestedFeatures = () => {
  return useQuery(requestedFeaturesQueryOptions());
};
